import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {
  resetForm!: FormGroup;
  showSuccessPopup = false;
  isDropdownOpen: boolean = false;

  constructor(private fb: FormBuilder, private apiService: ApiService, private cookieService: CookieService,
    private router: Router, private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.resetForm = this.fb.group(
      {
        oldPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validators: this.passwordMatchValidator
      }
    );
  }

  passwordMatchValidator(form: FormGroup) {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  onSubmit() {
    if (this.resetForm.valid) {
      const { oldPassword, newPassword } = this.resetForm.value;
      let payload = {
        "old_password": oldPassword,
        "new_password": newPassword
      }
      this.apiService.changePassword(payload).subscribe((res) => {
        this.showSuccessPopup = true;
        this.resetForm.reset();
      })
    }
  }

  showPasswordMismatchError(): boolean {
    const form = this.resetForm;
    return (
      form.hasError('passwordMismatch') &&
      (form.get('confirmPassword')?.dirty || form.get('confirmPassword')?.touched)
    );
  }

  logout() {
    this.commonService.logout();
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}